import type { UseFormReturn, SubmitHandler } from "react-hook-form";
import type { VerifyIdentitySchemaType } from "@/schemas/verifyIdentity.schema";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import OTPInput from "@/components/ui/otp-input";
import { MFAMessages } from "@/pages/Login/components/MFAMessages";
import { t } from "i18next";
import { Verify2FAStep } from "@/hooks/user/useVerify2FA";

interface Props {
  form: UseFormReturn<VerifyIdentitySchemaType>;
  step: Verify2FAStep;
  error: string | null;
  loading: boolean;
  onSubmit: (data: VerifyIdentitySchemaType) => void;
  onCancel: () => void;
}

export const VerifyIdentityForm = (props: Props): JSX.Element => {
  const onSubmit: SubmitHandler<VerifyIdentitySchemaType> = (data) => {
    props.onSubmit(data);
  };

  return (
    <div className="w-full space-y-3 mt-2">
      <MFAMessages errorId={props.error} />
      <div
        className="space-y-2"
        hidden={props.step != Verify2FAStep.ENTER_PASSWORD}
      >
        <Label>{t("components.verifyIdentity2FADialog.confirmPassword")}</Label>
        <Input type="password" {...props.form.register("password")} />
      </div>
      <div className="space-y-2" hidden={props.step != Verify2FAStep.ENTER_SMS}>
        <OTPInput
          onChangeOTP={(value) => {
            props.form.setValue("otp", value);
          }}
        />
      </div>
      <div className="flex justify-between">
        <Button
          disabled={props.loading}
          variant={"outline"}
          onClick={props.onCancel}
        >
          {t("components.verifyIdentity2FADialog.cancel")}
        </Button>
        <Button
          disabled={props.loading}
          variant={"default"}
          onClick={props.form.handleSubmit(onSubmit)}
        >
          {props.loading
            ? t("components.verifyIdentity2FADialog.buttonVerifying")
            : t("components.verifyIdentity2FADialog.buttonVerify")}
        </Button>
      </div>
      <div className="flex justify-end" id="verify-identity-form">
        <div id="recaptcha-container"></div>
      </div>
    </div>
  );
};
